import { OnDeckLogo } from '@odmonorepo/core-components';
import { Stack } from 'react-bootstrap';
import { Link } from '@tanstack/react-router';

export interface HeaderProps {
  fullName: string | never;
  businessName: string | never;
}

export function HeaderLogin() {
  return (
    <Stack direction="horizontal">
      <Link to="/">
        <OnDeckLogo width="150px" className="mb-4" />
      </Link>
    </Stack>
  );
}

export default HeaderLogin;
